// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3DWFU","notes":"Notes_notes__1Go1C","note":"Notes_note__da29E","markdown":"Notes_markdown__T8Ye9"};